(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var heading = event.target.closest('#t4s-footer [data-footer-open]');
    if (!heading) return;

    window.setTimeout(function() {
      var content = heading.nextElementSibling;
      var isOpen = heading.classList.contains('is--open') || heading.classList.contains('is--opend') || (content && content.offsetParent !== null && content.offsetHeight > 0);
      heading.classList.toggle('aureve-footer-open', isOpen);
      heading.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }, 80);
  });

  } catch(e) { console.error(e); }
})();
})();
